module.exports = __webpack_public_path__ + "media/src/images/favicon/favicon-16x16-073df22978be63821fb9c5a21f24afa9.png";